import { useMemo } from "react";
import { COMMERCIAL_RENEWAL_TRACKER_STEPS } from "../../../molecules/FormTracker";
import { useTorRules } from "../../BookingForm/hooks/useTorRules";

export const useCommercialRenewalSteps = () => {
  const { isBaseRentOnly } = useTorRules();

  const steps = useMemo(() => {
    if (!isBaseRentOnly) return COMMERCIAL_RENEWAL_TRACKER_STEPS;
    return COMMERCIAL_RENEWAL_TRACKER_STEPS.filter((step) => step.id !== "tor-rules");
  }, [isBaseRentOnly]);

  return {
    steps,
    totalSteps: steps.length,
  };
};
